mutation ApprovalResequencing($input: ApprovalResequencingInput!) {
  approvalResequencing(input: $input) {
    clientMutationId
    approvals {
      id
      badgeColor
      __typename
      _rowTimestamp
      _fullApprovalDescription
      priorityNumber
      description
      _infoLines {
        infoLine4
        infoLine3
        infoLine2
        infoLine1
        isTested
        activeTestCount
      }
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
    }
  }
}
